/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Dialog, IconButton } from "@mui/material";
import { DialogPanel } from "cms/icons/icon-selector/dialog-panel";
import { DialogActions } from "cms/icons/icon-selector/dialog-actions";
import { CloseOutlined } from "@ant-design/icons";

const IconSelectorDialog = (props) => {
    
    const {
        icon,
        setIcon,
        onSelectIcon,
        open = false,
        setOpen,
    } = props;
    
    const handleCancel = () => {
        setOpen(false);
    };
    const handleSelectIcon = async () => {
        onSelectIcon(icon);
        setOpen(false);
    };

    return (
        <Fragment>
            <>
                <Dialog
                    open={open}
                    onClose={handleCancel}
                    fullWidth={true}
                    maxWidth="sm"
                    className="simplicity-document-selector-overlay"
                >
                    <div className="base-dialog">
                        <div className="simplicity-document-selector-window-title">
                            
                            Icon Selector
                            
                            <IconButton onClick={handleCancel} style={{ marginLeft: "auto" }}>
                                <CloseOutlined />
                            </IconButton>
                        </div>
                        
                        <div className="simplicity-document-selector-window-content">
                            <div className="simplicity-document-selector-window-active">
                                
                                <DialogPanel
                                    icon={icon}
                                    setIcon={setIcon}
                                    onSelectIcon={onSelectIcon}
                                />
                                
                            </div>
                        </div>
                        
                        <DialogActions
                            handleCancel={handleCancel}
                            handleSelectIcon={handleSelectIcon}
                        />
                        
                    </div>
                </Dialog>
            </>
        </Fragment>
    );
};

IconSelectorDialog.displayName = "IconSelectorDialog";
export { IconSelectorDialog };
